// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Tuple_T2 from "../Data.Tuple.T2/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Orders_Payments_Dotpay_Types from "../Restaumatic.Orders.Payments.Dotpay.Types/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var Form = function (x) {
    return x;
};
var InvalidBlikCode = /* #__PURE__ */ (function () {
    function InvalidBlikCode() {

    };
    InvalidBlikCode.value = new InvalidBlikCode();
    return InvalidBlikCode;
})();
var CardProcessingError = /* #__PURE__ */ (function () {
    function CardProcessingError() {

    };
    CardProcessingError.value = new CardProcessingError();
    return CardProcessingError;
})();
var OtherError = /* #__PURE__ */ (function () {
    function OtherError(value0) {
        this.value0 = value0;
    };
    OtherError.create = function (value0) {
        return new OtherError(value0);
    };
    return OtherError;
})();
var DotpayChannel = /* #__PURE__ */ (function () {
    function DotpayChannel(value0) {
        this.value0 = value0;
    };
    DotpayChannel.create = function (value0) {
        return new DotpayChannel(value0);
    };
    return DotpayChannel;
})();
var P24Channel = /* #__PURE__ */ (function () {
    function P24Channel(value0) {
        this.value0 = value0;
    };
    P24Channel.create = function (value0) {
        return new P24Channel(value0);
    };
    return P24Channel;
})();
var StripeChannel = /* #__PURE__ */ (function () {
    function StripeChannel() {

    };
    StripeChannel.value = new StripeChannel();
    return StripeChannel;
})();
var ChannelInfo = function (x) {
    return x;
};
var PaymentRequest = function (x) {
    return x;
};
var eqForm = {
    eq: function (x) {
        return function (y) {
            return x.action === y.action && Data_Eq.eq(Data_Eq.eqArray(Data_Tuple_T2.eqT2(Data_Eq.eqString)(Data_Eq.eqString)))(x.fields)(y.fields);
        };
    }
};
var eqError = {
    eq: function (x) {
        return function (y) {
            if (x instanceof InvalidBlikCode && y instanceof InvalidBlikCode) {
                return true;
            };
            if (x instanceof CardProcessingError && y instanceof CardProcessingError) {
                return true;
            };
            if (x instanceof OtherError && y instanceof OtherError) {
                return x.value0 === y.value0;
            };
            return false;
        };
    }
};
var eqChannel = {
    eq: function (x) {
        return function (y) {
            if (x instanceof DotpayChannel && y instanceof DotpayChannel) {
                return Data_Eq.eq(Restaumatic_Orders_Payments_Dotpay_Types.eqChannelId)(x.value0)(y.value0);
            };
            if (x instanceof P24Channel && y instanceof P24Channel) {
                return x.value0 === y.value0;
            };
            if (x instanceof StripeChannel && y instanceof StripeChannel) {
                return true;
            };
            return false;
        };
    }
};
var eqChannelInfo = {
    eq: function (x) {
        return function (y) {
            return x.enabled === y.enabled && Data_Eq.eq(eqChannel)(x.id)(y.id) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.logo)(y.logo) && x.name === y.name;
        };
    }
};
var eqPaymentRequest = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.blikCode)(y.blikCode) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.cardToken)(y.cardToken) && Data_Eq.eq(eqChannel)(x.channel)(y.channel) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqBoolean))(x.isIosApp)(y.isIosApp);
        };
    }
};
var newtypePaymentRequest = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeForm = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeChannelInfo = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldPaymentRequest = function (dictHasField) {
    return dictHasField;
};
var hasFieldForm = function (dictHasField) {
    return dictHasField;
};
var hasFieldChannelInfo = function (dictHasField) {
    return dictHasField;
};
var genericPaymentRequest = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericForm = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showForm = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericForm)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "action";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "fields";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Tuple_T2.showT2(Data_Show.showString)(Data_Show.showString))))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "Form";
        }
    }))
};
var unscrambleDecodeForm = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericForm)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "action";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "fields";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(/* #__PURE__ */ Data_Tuple_T2.udecodeT2(Unscramble.decodeString1)(Unscramble.decodeString1)))(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var genericError = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return InvalidBlikCode.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return CardProcessingError.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return new OtherError(x.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Payments.Types (line 29, column 1 - line 29, column 65): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof InvalidBlikCode) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof CardProcessingError) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof OtherError) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Payments.Types (line 29, column 1 - line 29, column 65): " + [ x.constructor.name ]);
    }
};
var showError = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericError)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "InvalidBlikCode";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "CardProcessingError";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))({
        reflectSymbol: function () {
            return "OtherError";
        }
    }))))
};
var unscrambleDecodeError = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericError)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "InvalidBlikCode";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "CardProcessingError";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "OtherError";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Unscramble.decodeString1))))))(Unscramble_Generic.defaultOptions)
};
var genericChannelInfo = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericChannel = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new DotpayChannel(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new P24Channel(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return StripeChannel.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Payments.Types (line 16, column 1 - line 16, column 69): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof DotpayChannel) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof P24Channel) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof StripeChannel) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Payments.Types (line 16, column 1 - line 16, column 69): " + [ x.constructor.name ]);
    }
};
var showChannel = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericChannel)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Orders_Payments_Dotpay_Types.showChannelId))({
        reflectSymbol: function () {
            return "DotpayChannel";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showInt))({
        reflectSymbol: function () {
            return "P24Channel";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "StripeChannel";
        }
    }))))
};
var showChannelInfo = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericChannelInfo)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "enabled";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "id";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "logo";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(showChannel))(Data_Show.showBoolean))))({
        reflectSymbol: function () {
            return "ChannelInfo";
        }
    }))
};
var showPaymentRequest = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPaymentRequest)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "blikCode";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "cardToken";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "channel";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "isIosApp";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showBoolean)))(showChannel))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))))({
        reflectSymbol: function () {
            return "PaymentRequest";
        }
    }))
};
var unscrambleDecodeChannel = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecodeTagged(genericChannel)(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "DotpayChannel";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Restaumatic_Orders_Payments_Dotpay_Types.unscrambleDecodeChannelId)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "P24Channel";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Unscramble.decodeInt1)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "StripeChannel";
        }
    }))))(Unscramble_Generic.defaultOptions)
};
var unscrambleDecodeChannelInfo = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericChannelInfo)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "enabled";
        }
    })(Unscramble.decodeBoolean1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "id";
        }
    })(unscrambleDecodeChannel)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "logo";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "name";
        }
    })(Unscramble.decodeString1)(Unscramble.decodeRecordNil))))))))(Unscramble_Generic.defaultOptions)
};
var unscrambleDecodePaymentRequest = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPaymentRequest)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "blikCode";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "cardToken";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "channel";
        }
    })(unscrambleDecodeChannel)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "isIosApp";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeBoolean1))(Unscramble.decodeRecordNil))))))))(Unscramble_Generic.defaultOptions)
};
var encodingOpts = /* #__PURE__ */ (function () {
    return {
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        unwrapSingleRecordArguments: true,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    };
})();
var encodeForm = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericForm)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Form";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "fields";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(/* #__PURE__ */ Data_Tuple_T2.encodeT2(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))))))({
        reflectSymbol: function () {
            return "action";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(encodingOpts)
};
var encodeError = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericError)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "InvalidBlikCode";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "CardProcessingError";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "OtherError";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(encodingOpts)
};
var encodeChannel = /* #__PURE__ */ (function () {
    return {
        encode: Foreign_Generic.genericEncode(genericChannel)(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor({
            reflectSymbol: function () {
                return "DotpayChannel";
            }
        })(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Orders_Payments_Dotpay_Types.encodeChannelId))))(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor({
            reflectSymbol: function () {
                return "P24Channel";
            }
        })(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode))))(Foreign_Generic_Class.genericEncodeConstructor({
            reflectSymbol: function () {
                return "StripeChannel";
            }
        })(Foreign_Generic_Class.genericEncodeArgsNoArguments))))({
            sumEncoding: encodingOpts.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: encodingOpts.unwrapSingleArguments,
            unwrapSingleRecordArguments: encodingOpts.unwrapSingleRecordArguments,
            fieldTransform: encodingOpts.fieldTransform
        })
    };
})();
var encodeChannelInfo = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericChannelInfo)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ChannelInfo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "logo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "id";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeChannel)))({
        reflectSymbol: function () {
            return "enabled";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode))))))(encodingOpts)
};
var encodePaymentRequest = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericPaymentRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "PaymentRequest";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "isIosApp";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.booleanEncode))))({
        reflectSymbol: function () {
            return "channel";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeChannel)))({
        reflectSymbol: function () {
            return "cardToken";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "blikCode";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode)))))))(encodingOpts)
};
var decodeForm = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericForm)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Form";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "fields";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(/* #__PURE__ */ Data_Tuple_T2.decodeT2(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode)))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))))))())({
        reflectSymbol: function () {
            return "action";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeError = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericError)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "InvalidBlikCode";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "CardProcessingError";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "OtherError";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode)))(Foreign_Generic_Class.genericCountArgsArgument))))(encodingOpts)
};
var decodeChannel = /* #__PURE__ */ (function () {
    return {
        decode: Foreign_Generic.genericDecode(genericChannel)(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor({
            reflectSymbol: function () {
                return "DotpayChannel";
            }
        })(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Orders_Payments_Dotpay_Types.decodeChannelId)))(Foreign_Generic_Class.genericCountArgsArgument))(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor({
            reflectSymbol: function () {
                return "P24Channel";
            }
        })(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode)))(Foreign_Generic_Class.genericCountArgsArgument))(Foreign_Generic_Class.genericDecodeConstructor({
            reflectSymbol: function () {
                return "StripeChannel";
            }
        })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))))({
            sumEncoding: encodingOpts.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: encodingOpts.unwrapSingleArguments,
            unwrapSingleRecordArguments: encodingOpts.unwrapSingleRecordArguments,
            fieldTransform: encodingOpts.fieldTransform
        })
    };
})();
var decodeChannelInfo = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericChannelInfo)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ChannelInfo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "logo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "id";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeChannel))())({
        reflectSymbol: function () {
            return "enabled";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodePaymentRequest = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericPaymentRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "PaymentRequest";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "isIosApp";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.booleanDecode)))())({
        reflectSymbol: function () {
            return "channel";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeChannel))())({
        reflectSymbol: function () {
            return "cardToken";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "blikCode";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
export {
    DotpayChannel,
    P24Channel,
    StripeChannel,
    InvalidBlikCode,
    CardProcessingError,
    OtherError,
    ChannelInfo,
    Form,
    PaymentRequest,
    encodingOpts,
    genericChannel,
    showChannel,
    eqChannel,
    decodeChannel,
    unscrambleDecodeChannel,
    encodeChannel,
    genericError,
    showError,
    eqError,
    decodeError,
    unscrambleDecodeError,
    encodeError,
    genericChannelInfo,
    showChannelInfo,
    eqChannelInfo,
    decodeChannelInfo,
    unscrambleDecodeChannelInfo,
    encodeChannelInfo,
    newtypeChannelInfo,
    hasFieldChannelInfo,
    genericForm,
    showForm,
    eqForm,
    decodeForm,
    unscrambleDecodeForm,
    encodeForm,
    newtypeForm,
    hasFieldForm,
    genericPaymentRequest,
    showPaymentRequest,
    eqPaymentRequest,
    decodePaymentRequest,
    unscrambleDecodePaymentRequest,
    encodePaymentRequest,
    newtypePaymentRequest,
    hasFieldPaymentRequest
};
//# sourceMappingURL=index.js.map
